class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, selectedVariantId) {
    // Multi-item gift additions return {items, sections}, not a top-level item key.
    const addedItem = parsedState.key ? parsedState :
      (Array.isArray(parsedState.items) ? parsedState.items.find((item) =>
        String(item.variant_id || item.id) === String(selectedVariantId)) : null);
    this.cartItemKey = addedItem && addedItem.key;
    try {
      if (!this.cartItemKey) throw new Error('Added item key is missing');
      // Resolve every section before updating the DOM to avoid a partial notification.
      const updates = this.getSectionsToRender().map((section) => {
        const target = document.getElementById(section.id);
        const html = parsedState.sections && parsedState.sections[section.id];
        if (!target || typeof html !== 'string') throw new Error('Cart section is missing');
        return { target, html: this.getSectionInnerHTML(html, section.selector) };
      });
      updates.forEach((update) => { update.target.innerHTML = update.html; });
    } catch (error) {
      // Addition already succeeded: show the actual cart; never retry the add request.
      window.location.assign(window.routes.cart_url);
      return;
    }
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

